import { render, staticRenderFns } from "./PlvLiveLogin.vue?vue&type=template&id=afa23ab2&scoped=true&"
import script from "@/scripts/PlvLiveLogin/index.js?vue&type=script&lang=js&"
export * from "@/scripts/PlvLiveLogin/index.js?vue&type=script&lang=js&"
import style0 from "./PlvLiveLogin.vue?vue&type=style&index=0&id=afa23ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa23ab2",
  null
  
)

export default component.exports